export const dailyBonus = {
  title: "デイリーボーナス",
  received: "本日のボーナスは受取済みです",
  pointsEarned: (args: { count: string | number }) => `${args.count}pt獲得！`,
  streak: {
    dayUnit: "日連続",
    untilGrand: (args: { count: string | number }) =>
      `1,000ptゲットまで あと ${args.count} 日`,
  },
  returning: {
    title: "本日のボーナスは受け取り済みです",
  },
  free: {
    stampPreview: "スタンプカード",
    lockedTitle: "ポイント購入者限定",
    lockedDescription: "ポイント課金で解放されます",
    lockedRewardLead: "30日連続でダブルデイリーボーナスを受け取ると",
    lockedRewardPoint: "1,000pt",
    lockedRewardTail: "もらえる！",
  },
  upsell: {
    badge: "ポイント購入者限定",
    title: "ポイントを購入して\nダブルデイリーボーナスを受け取ろう",
    description:
      "ポイントを購入すると\n30日連続ログインで 1,000pt プレゼント。",
    cta: "ポイントを購入する",
  },
  modal: {
    dailyLabel: "DAILY LOGIN BONUS",
    grandLabel: "GRAND LOGIN BONUS",
    grandTitle: "30日連続達成！",
    received: (args: { count: string | number }) =>
      `ログインボーナスとして\n${args.count}ポイント受け取りました`,
    grandReceived: (args: { count: string | number }) =>
      `30日連続ログインの達成ボーナス\n${args.count}ポイントを受け取りました`,
    close: "閉じる",
  },
  doubleBonus: {
    expiryWarning: (args: { count: string | number }) =>
      `ダブルデイリーボーナスの期限まで あと ${args.count} 日です`,
    purchaseToExtend: "ポイントを購入すると期限が延長されます",
    extendCta: "ポイントを購入する",
  },
  promo: {
    countdown: {
      day: "日",
      hour: "時",
      min: "分",
      sec: "秒",
      remaining: "残り",
    },
    headline: {
      spotlight: "あなただけにお得な情報!!",
      purchaseFirst: "初回購入限定!! 今だけ大盤振る舞い",
      purchaseNth: (args: { count: string | number }) =>
        `${args.count}回目購入限定!! 今だけ大盤振る舞い`,
      method: "デイリーボーナスを1日20ptにする方法",
    },
    deal: {
      ariaLabel: "ポイント購入で1,200pt分お得",
    },
    daily: {
      ariaLabel: "デイリーボーナスを受け取ろう",
    },
  },
  infoModal: {
    badge: "ポイント購入者限定",
    catchphrase: "＼ 毎日をお得にしませんか? ／",
    title: "ダブルデイリーボーナス",
    subtitleLead: "ポイント購入で31日間、毎日 ",
    subtitleMultiplier: "2倍!!",
    step1: "お好きなコースでポイントを購入",
    step2: "翌日から「マイページ」のデイリーボーナスをタップ",
    step3Lead: "毎日1回 ",
    step3Point: "20pt",
    step3Tail: " もらえる!",
    cta: "ポイントを購入する",
    later: "あとで",
    close: "閉じる",
  },
} as const;
